import { render, staticRenderFns } from "./BaseNoResults.vue?vue&type=template&id=d05fa61c&"
import script from "./BaseNoResults.vue?vue&type=script&lang=js&"
export * from "./BaseNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports